export default angular.module("vesl.filters.capitalize", [])
	.filter("capitalize", function() {
		return function(code) {
			if(!code) {
				return code; 
			}
      
			// Capitalize the first character and lowercase the rest
			return code.charAt(0).toUpperCase() + code.slice(1).toLowerCase();
		};
	})
	.name;